import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router'
import store from '@/store'

// 创建axios实例
const service = axios.create({
  baseURL: '/api',
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = store.state.token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res instanceof Blob) {
      return res
    }
    if (res.code === 401) {
      Toast.fail(res.msg || '登录已过期')
      store.dispatch('logout')
      router.push('/login')
      return Promise.reject(new Error(res.msg))
    }
    if (res.code !== 200) {
      Toast.fail(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg))
    }
    return res
  },
  error => {
    Toast.fail('网络异常')
    return Promise.reject(error)
  }
)

export default service

// ============ 用户API ============
export const userApi = {
  login: (data) => service.post('/user/login', data),
  register: (data) => {
    if (data instanceof FormData) {
      return service.post('/user/register', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    }
    return service.post('/user/register', data)
  },
  checkShareCode: (shareCode) => service.get('/user/checkShareCode', { params: { shareCode } }),
  getUserInfo: () => service.get('/user/info'),
  updatePassword: (data) => service.post('/user/updatePassword', data),
  updateUser: (data) => service.put('/user/update', data),
  updateProfile: (data) => {
    const formData = new FormData()
    if (data.file) formData.append('file', data.file)
    if (data.userName) formData.append('userName', data.userName)
    return service.post('/user/updateProfile', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  getDirectMembers: (params) => service.get('/user/directMembers', { params }),
  getDirectMembersByUserId: (userId, params) => service.get(`/user/directMembers/${userId}`, { params }),
  toggleStatus: (userId) => service.post(`/user/toggleStatus/${userId}`),
  sendCode: (phone) => service.post('/user/sendCode', { phone }),
  resetPassword: (data) => service.post('/user/resetPassword', data)
}

// ============ 公告API ============
export const noticeApi = {
  getList: (params) => service.get('/notice/list', { params }),
  getMyList: (params) => service.get('/notice/myList', { params }),
  getBannerList: () => service.get('/notice/bannerList'),
  getDetail: (noticeId) => service.get(`/notice/${noticeId}`),
  add: (data) => service.post('/notice/add', data),
  update: (data) => service.put('/notice/update', data),
  delete: (noticeId) => service.delete(`/notice/${noticeId}`),
  cancelTop: () => service.post('/notice/cancelTop'),
  getShareList: (params) => service.get('/notice/shareList', { params }),
  getShareBannerList: () => service.get('/notice/shareBannerList'),
  getMyBannerList: () => service.get('/notice/myBannerList')
}

// ============ Banner API ============
export const bannerApi = {
  getList: () => service.get('/banner/list')
}

// ============ 文章API ============
export const articleApi = {
  getList: (params) => service.get('/article/list', { params }),
  getDetail: (articleId) => service.get(`/article/${articleId}`),
  add: (data) => service.post('/article/add', data),
  update: (data) => service.put('/article/update', data),
  delete: (articleId) => service.delete(`/article/${articleId}`),
  getPublishedList: () => service.get('/article/publishedList')
}

// ============ 会员管理API（管理员） ============
export const memberApi = {
  getList: (params) => service.get('/member/list', { params }),
  getDirectMembers: (userId, params) => service.get(`/member/directMembers/${userId}`, { params }),
  toggleStatus: (userId) => service.post(`/member/toggleStatus/${userId}`),
  resetPassword: (userId, newPassword) => service.post(`/member/resetPassword/${userId}`, { newPassword }),
  pauseMember: (userId) => service.post(`/user/pause/${userId}`),
  resumeMember: (userId) => service.post(`/user/resume/${userId}`),
  toggleViewPermission: (userId) => service.post(`/member/toggleViewPermission/${userId}`),
  updateColor: (userId, color) => service.post(`/member/updateColor/${userId}`, { color }),
  getStats: () => service.get('/member/stats'),
  getByDateRange: (params) => service.get('/member/byDateRange', { params }),
  exportAllMembers: () => service.get('/member/export', { responseType: 'blob' }),
  exportDirectMembers: (phone) => service.get('/member/exportDirect', { params: { phone }, responseType: 'blob' }),
  downloadImportTemplate: () => service.get('/member/import/template', { responseType: 'blob' }),
  importMembers: (data) => service.post('/member/import', data),
  moveMember: (phone, newSharePhone) => service.post('/member/move', { phone, newSharePhone })
}
